import type { PermissionData } from '../types'

export function computeVehicleJsonPermission(permissionData: PermissionData) {
  if (!permissionData.isDev) return 'hidden'
  if (permissionData.routesCount !== 1) return 'hidden'

  return 'enabled'
}
